import { render, staticRenderFns } from "./customerOfBank.vue?vue&type=template&id=cd997cc6&scoped=true&"
import script from "./customerOfBank.vue?vue&type=script&lang=js&"
export * from "./customerOfBank.vue?vue&type=script&lang=js&"
import style0 from "./customerOfBank.vue?vue&type=style&index=0&id=cd997cc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd997cc6",
  null
  
)

export default component.exports